<template>
  <div class="setting_block">
    <div ref="leftBlock" class="left_block">
      <template v-for="(item, x) in leftMatrix" v-bind:key="x">
        <template v-for="(_item, y) in item" v-bind:key="y">
          <div :style="getStyle(_item, x, y, 'left')">
            <div :style="getBgStyle(_item, x, y)" class="absolute imgBg_sS"></div>
            <input v-if="_item.key" v-model="_item.isCheck" type="checkbox" class="absolute checkbox_sS" @change="unitSelected" />
            <template v-if="_item.key">
              <el-select @change="changeStore" v-model="_item.componentKey" class="absolute select_sS">
                <el-option v-for="(selItem, n) in getComponents(leftMatrix, x, y)" v-bind:key="n" :label="selItem.key" :value="selItem.uuid"></el-option>
              </el-select>
            </template>
          </div>
        </template>
      </template>
      <el-button @click="combineSelect_left('l')" type="primary" plain class="absolute leftButton_sS">合并</el-button>
      <el-button @click="splitSelectMulti_left('l')" type="primary" style="right: 6rem" plain class="absolute leftButton_sS">拆分</el-button>
    </div>
    <div ref="rightBlock" class="right_block">
      <template v-for="(item, x) in rightMatrix" v-bind:key="x">
        <template v-for="(_item, y) in item" v-bind:key="y">
          <div :style="getStyle(_item, x, y, 'right')">
            <div :style="getBgStyle(_item, x, y)" class="absolute imgBg_sS"></div>
            <input v-if="_item.key" v-model="_item.isCheck" type="checkbox" class="absolute checkbox_sS" @change="unitSelected" />
            <template v-if="_item.key">
              <el-select @change="changeStore" v-model="_item.componentKey" class="absolute select_sS">
                <el-option v-for="(selItem, n) in getComponents(rightMatrix, x, y)" v-bind:key="n" :label="selItem.key" :value="selItem.uuid"></el-option>
              </el-select>
            </template>
          </div>
        </template>
      </template>
      <el-button @click="splitSelectMulti_right('r')" type="primary" plain style="left: 6rem" class="absolute rightButton_sS">拆分</el-button>
      <el-button @click="combineSelect_right('r')" type="primary" plain class="absolute rightButton_sS">合并</el-button>
    </div>
    <div class="saveButton">
      <p>是否保存当前配置至云端</p>
      <div class="button_box">
        <el-tooltip popper-class="tooltipBox" class="item" effect="light" placement="top">
          <template #content> 仅在缓存中保留此次更改，<br />清除缓存后即恢复之前配置</template>
          <el-button class="cancel" @click="cancelClick">取消</el-button>
        </el-tooltip>
        <el-button class="save" @click="saveClick">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import { useStore, mapState, mapGetters } from "vuex";

import { storageGet } from "@/utils/tools.js";

export default {
  //import引入的组件需要注入到对象中才能使用
  name: "settingPart",
  components: {},
  props: ["modelType"],
  /*setup(props) {
    const store = useStore();
    const unitH = window.bmeConfig.DIY_H;
    const unitW = window.bmeConfig.DIY_W;
    const blockList = new Array(12); //组件块数
    const left_Xnum = store.state.leftPartX;
    const left_Ynum = store.state.leftPartY;
    const right_Xnum = store.state.rightPartX;
    const right_Ynum = store.state.rightPartY;
    const componentsObj = window.componentsObj;
    const leftMatrix = [];
    const rightMatrix = [];
    const settingMod = props.modelType;
    return {
      unitH,
      unitW,
      blockList,
      left_Xnum,
      left_Ynum,
      right_Xnum,
      right_Ynum,
      componentsObj,
      leftMatrix,
      rightMatrix,
      settingMod,
    };
  },*/
  data() {
    //这里存放数据
    return {
      customerId: this.$store.state.customerId,
      unitH: window.bmeConfig.DIY_H,
      unitW: window.bmeConfig.DIY_W,
      blockList: new Array(12), //组件块数
      left_Xnum: this.$store.state.leftPartX,
      left_Ynum: this.$store.state.leftPartY,
      right_Xnum: this.$store.state.rightPartX,
      right_Ynum: this.$store.state.rightPartY,
      componentsObj: window.componentsObj,
      leftMatrix: [],
      rightMatrix: [],
      settingMod: this.modelType,
      componentTiny: "",
    };
  },
  watch: {
    curComponentTiny: {
      handler(newVal, oldVal) {
        this.componentTiny = newVal;
        this.initFunc();
        this.mountedFunc();
      },
      deep: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.initFunc();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.mountedFunc();
  },
  //计算属性 类似于data概念
  computed: {
    ...mapGetters({
      leftMatix_init: "initLeftMatrix",
      rightMatix_init: "initRightMatrix",
    }),
    ...mapState({
      leftMatix_store: "leftPartMatrix",
      rightMatix_store: "rightPartMatrix",
    }),
    getStyle() {
      return function (item, x, y, type) {
        let left = x * (this.unitW ? this.unitW : 0);
        let top = y * (this.unitH ? this.unitH : 0);
        let isShow = "";
        if (type === "right") {
          isShow = this.componentTiny && item.x <= 1 ? "none" : "";
        } else {
          isShow = this.componentTiny && item.x >= 2 ? "none" : "";
        }
        return {
          position: "absolute",
          left: left + "px",
          top: top + "px",
          width: (this.unitW ? this.unitW : 0) + "px",
          height: (this.unitH ? this.unitH : 0) + "px",
          border: "1px solid #000",
          display: isShow,
        };
      };
    },
    getBgStyle() {
      return function (item, x, y) {
        let imgH, imgW;
        if (item.key == "0#0@1#0") {
          imgH = 1;
          imgW = 2;
        } else if (item.key == "0#0") {
          imgH = 1;
          imgW = 1;
        } else if (item.key == "0#0@1#0@2#0") {
          imgH = 1;
          imgW = 3;
        } else if (item.key == "0#0@0#1") {
          imgH = 2;
          imgW = 1;
        } else if (item.key == "0#0@1#0@0#1@1#1") {
          imgH = 2;
          imgW = 2;
        } else if (item.key == "0#0@1#0@2#0@0#1@1#1@2#1@0#3@1#3@2#3") {
          imgH = 3;
          imgW = 3;
        }
        return {
          width: imgW * (this.unitW ? this.unitW : 0) - 10 + "px",
          height: imgH * (this.unitH ? this.unitH : 0) - 10 + "px",
          // border: '1px solid #000',
          background: "url(./static/img/" + item.componentKey + ".png)",
          backgroundSize: "100% 100%",
          backgroundRepeat: "no-repeat",
        };
      };
    },
    curComponentTiny() {
      return this.$store.state.componentTiny;
    },
    getComponents() {
      return function (item, i, j) {
        let key = item[i][j]["key"];
        let components = this.componentsObj
          ? this.componentsObj[key]
          : window.componentsObj[key];
        return components;
      };
    },
  },
  //方法集合
  methods: {
    initFunc() {
      this.unitH = window.bmeConfig.DIY_H;
      this.unitW = window.bmeConfig.DIY_W;
      this.blockList = new Array(12); //组件块数
      this.componentTiny = this.$store.state.componentTiny;
      this.left_Xnum = this.$store.state.leftPartX;
      this.left_Ynum = this.$store.state.leftPartY;
      this.right_Xnum = this.$store.state.rightPartX;
      this.right_Ynum = this.$store.state.rightPartY;
      this.componentsObj = window.componentsObj;
      this.leftMatrix = [];
      this.rightMatrix = [];
      this.settingMod = this.modelType;

      if ($.isEmptyObject(this.leftMatix_store[this.settingMod])) {
        this.leftMatrix = this.leftMatix_init;
        //第一次创建时从缓存中拿值
        if (this.modelType) {
          let storageKey = "leftPartMatrix-" + this.modelType;
          let obj = storageGet(storageKey);
          if (!$.isEmptyObject(obj)) {
            this.leftMatrix = obj;
          }
        }
        let len = this.leftMatrix.length;
        for (let i = 0; i < len; i++) {
          let tmpList = this.leftMatrix[i];
          for (let j = 0; j < tmpList.length; j++) {
            if (jQuery.isEmptyObject(tmpList[j])) {
              tmpList[j] = this.initUnit(i, j, "l");
            }
          }
        }
        this.syncPartMatrix(this.leftMatrix, "l");
      } else {
        this.leftMatrix = this.leftMatix_store[this.settingMod];
      }
      if ($.isEmptyObject(this.rightMatix_store[this.settingMod])) {
        this.rightMatrix = this.rightMatix_init;
        //第一次创建时从缓存中拿值
        if (this.modelType) {
          let storageKey = "rightPartMatrix-" + this.modelType;
          let obj = storageGet(storageKey);
          if (!$.isEmptyObject(obj)) {
            this.rightMatrix = obj;
            /*if (!this.componentTiny) {
              this.rightMatrix = obj;
            } else {
              this.rightMatrix = [];
              for (var i = 0; i < 2; i++) {
                this.rightMatrix.push(obj[i]);
              }
            }*/
          }
        }
        let len = this.rightMatrix.length;
        for (let i = 0; i < len; i++) {
          let tmpList = this.rightMatrix[i];
          for (let j = 0; j < tmpList.length; j++) {
            if (jQuery.isEmptyObject(tmpList[j])) {
              tmpList[j] = this.initUnit(i, j, "r");
            }
          }
        }
        this.syncPartMatrix(this.rightMatrix, "r");
      } else {
        this.rightMatrix = this.rightMatix_store[this.settingMod];
      }
        console.log(this.leftMatrix)

    },
    mountedFunc() {
      let that = this;
      that.$refs.leftBlock.style.height = that.left_Ynum * that.unitH + "px";
      that.$refs.leftBlock.style.width = that.left_Xnum * that.unitW + "px";
      that.$refs.rightBlock.style.height = that.right_Ynum * that.unitH + "px";
      that.$refs.rightBlock.style.width = that.right_Xnum * that.unitW + "px";
      console.log(that.left_Xnum * that.unitW, 'that.left_Xnum * that.unitW')
      let this_ = that;
      setTimeout(function () {
        $(this_.$refs.leftBlock).addClass("left_slider_in");

        $(this_.$refs.rightBlock).addClass("right_slider_in");
      }, 50);
    },
    returnFuc(){
     let path_name = this.$router.currentRoute.value.name;
      if (!path_name) {
        path_name = "MainMod";
      }
      this.$router.push({
        path: "/" + (path_name == "MainMod" ? "MainMod" : path_name),
        query: {
          setting: "false",
        },
      });
    },
    cancelClick() {
      // updateToWeb = false;
      this.returnFuc();
    },
    saveClick() {
     // updateToWeb = true;
      //将数据推送到云端并返回
      this.postWebComponentData();
      this.returnFuc();
    },
    //将二维空数组注入参数
    postWebComponentData() {
      let url =CONFIG.requestName +
        "/componentJson/updateCustomerComponent";

      let localStorageArr = Object.keys(localStorage).filter(
        (i) =>
          i.startsWith("leftPartMatrix-") || i.startsWith("rightPartMatrix-")
      );
      let submitData = {};
      localStorageArr.forEach((i) => {
        submitData[i] = localStorage[i];
      });
      let params = {
        customerId: bmeConfig.componentMockCustomerId ||  this.customerId,
        componentJson: JSON.stringify(submitData)
      };
      this.$apiUtils.post(url, params);
    },
    initUnit(i, j, type) {
      let cur_Xnum;
      if (type == "l") {
        cur_Xnum = this.left_Xnum;
      } else {
        cur_Xnum = this.right_Xnum;
      }
      return {
        x: i,
        y: j,
        isCheck: false,
        key: this.keyProcess(i + "#" + j),
        protoKey: i + "#" + j,
        sort: i + j * cur_Xnum,
        componentKey: "",
        components: this.componentsObj[this.keyProcess(i + "#" + j)],
      };
    },
    //数组逼近
    keyProcess(val) {
      let list = val.split("@");
      let resultList = [];
      if (val && list.length > 0) {
        let fst = list[0];
        let deltaX = fst.split("#")[0];
        let deltaY = fst.split("#")[1];
        for (let i = 0; i < list.length; i++) {
          let tmp = list[i];
          let tmpX = tmp.split("#")[0];
          let tmpY = tmp.split("#")[1];
          tmpX = tmpX - deltaX;
          tmpY = tmpY - deltaY;
          let str = tmpX + "#" + tmpY;
          resultList.push(str);
        }
        return resultList.join("@");
      } else {
        return "";
      }
    },
    unitSelected() {},
    //合并
    combineSelect_left() {
      let list = [];
      for (let i = 0; i < this.leftMatrix.length; i++) {
        let tmpList = this.leftMatrix[i];
        for (let j = 0; j < tmpList.length; j++) {
          let tmp = tmpList[j];
          if (tmp["isCheck"]) {
            list.push(tmp);
          }
        }
      }
      list = list.sort(function (a, b) {
        return a["sort"] - b["sort"];
      });

      let protoKeyList = [];
      for (let i = 0; i < list.length; i++) {
        let tmp = list[i];
        let str = tmp["protoKey"] ? tmp["protoKey"] : tmp.x + "#" + tmp.y;
        protoKeyList.push(str);
      }
      for (let i = 0; i < list.length; i++) {
        if (i === 0) {
          list[i]["protoKey"] = protoKeyList.join("@");
          list[i]["key"] = this.keyProcess(list[i]["protoKey"]);
          var components = this.componentsObj[list[i]["key"]];

          if ($.isEmptyObject(components) || components.length == 0) {
            this.$message.error("没有该类型组件，无法合并");
            return;
          }

          list[i]["components"] = !$.isEmptyObject(components)
            ? components
            : [];
          list[i]["componentKey"] =
            !$.isEmptyObject(components) && components.length > 0
              ? components[0]["uuid"]
              : "";
        } else {
          list[i]["key"] = "";
        }
        list[i]["isCheck"] = "";
      }
      this.syncPartMatrix(this.leftMatrix, "l");
      this.$forceUpdate();
    },
    combineSelect_right() {
      let list = [];
      for (let i = 0; i < this.rightMatrix.length; i++) {
        let tmpList = this.rightMatrix[i];
        for (let j = 0; j < tmpList.length; j++) {
          let tmp = tmpList[j];
          if (tmp["isCheck"]) {
            list.push(tmp);
          }
        }
      }
      list = list.sort(function (a, b) {
        return a["sort"] - b["sort"];
      });

      let protoKeyList = [];
      for (let i = 0; i < list.length; i++) {
        let tmp = list[i];
        let str = tmp["protoKey"] ? tmp["protoKey"] : tmp.x + "#" + tmp.y;
        protoKeyList.push(str);
      }
      for (let i = 0; i < list.length; i++) {
        if (i === 0) {
          list[i]["protoKey"] = protoKeyList.join("@");
          list[i]["key"] = this.keyProcess(list[i]["protoKey"]);
          var components = this.componentsObj[list[i]["key"]];

          if ($.isEmptyObject(components) || components.length == 0) {
            this.$message.error("没有该类型组件，无法合并");
            return;
          }

          list[i]["components"] = !$.isEmptyObject(components)
            ? components
            : [];
          list[i]["componentKey"] =
            !$.isEmptyObject(components) && components.length > 0
              ? components[0]["uuid"]
              : "";
        } else {
          list[i]["key"] = "";
        }
        list[i]["isCheck"] = "";
      }
      this.syncPartMatrix(this.rightMatrix, "r");
      this.$forceUpdate();
    },
    //拆分
    splitSelectMulti_left() {
      let list = [];
      for (let i = 0; i < this.leftMatrix.length; i++) {
        let tmpList = this.leftMatrix[i];
        for (let j = 0; j < tmpList.length; j++) {
          let tmp = tmpList[j];
          if (tmp["isCheck"]) {
            this.splitSelectSingle_left(tmp);
          }
        }
      }
    },
    splitSelectMulti_right() {
      let list = [];
      for (let i = 0; i < this.rightMatrix.length; i++) {
        let tmpList = this.rightMatrix[i];
        for (let j = 0; j < tmpList.length; j++) {
          let tmp = tmpList[j];
          if (tmp["isCheck"]) {
            this.splitSelectSingle_right(tmp);
          }
        }
      }
    },
    splitSelectSingle_left(obj) {
      let list = obj.protoKey.split("@");
      let components = this.componentsObj["0#0"];
      let componentKey =
        !$.isEmptyObject(components) && components.length > 0
          ? components[0]["val"]
          : "";
      if (list.length > 1) {
        for (let i = 0; i < list.length; i++) {
          if (i === 0) {
            obj["protoKey"] = obj.x + "#" + obj.y;
            obj["key"] = this.keyProcess(obj["protoKey"]);
            obj["components"] = components;
            obj["componentKey"] = "";
          } else {
            let tag = list[i];
            for (let j = 0; j < this.leftMatrix.length; j++) {
              let tmpList = this.leftMatrix[j];
              for (let k = 0; k < tmpList.length; k++) {
                if (tmpList[k]["protoKey"] == tag && !tmpList[k]["key"]) {
                  tmpList[k]["key"] = this.keyProcess(tmpList[k]["protoKey"]);
                  obj["components"] = components;
                  obj["componentKey"] = "";
                  break;
                }
              }
            }
          }
        }
      }
      obj.isCheck = "";
      this.syncPartMatrix(this.leftMatrix, "l");
      this.$forceUpdate();
    },
    splitSelectSingle_right(obj) {
      let list = obj.protoKey.split("@");
      let components = this.componentsObj["0#0"];
      let componentKey =
        !$.isEmptyObject(components) && components.length > 0
          ? components[0]["val"]
          : "";
      if (list.length > 1) {
        for (let i = 0; i < list.length; i++) {
          if (i === 0) {
            obj["protoKey"] = obj.x + "#" + obj.y;
            obj["key"] = this.keyProcess(obj["protoKey"]);
            obj["components"] = components;
            obj["componentKey"] = "";
          } else {
            let tag = list[i];
            for (let j = 0; j < this.rightMatrix.length; j++) {
              let tmpList = this.rightMatrix[j];
              for (let k = 0; k < tmpList.length; k++) {
                if (tmpList[k]["protoKey"] == tag && !tmpList[k]["key"]) {
                  tmpList[k]["key"] = this.keyProcess(tmpList[k]["protoKey"]);
                  obj["components"] = components;
                  obj["componentKey"] = "";
                  break;
                }
              }
            }
          }
        }
      }
      obj.isCheck = "";
      this.syncPartMatrix(this.rightMatrix, "r");
      this.$forceUpdate();
    },
    changeStore() {
      this.syncPartMatrix(this.leftMatrix, "l");
      this.syncPartMatrix(this.rightMatrix, "r");
    },
    //同步到全局
    syncPartMatrix(obj, type) {
      try {
        obj.forEach((x) => {
          x.forEach((y) => {
            y.components = "";
          });
        });
      } catch (err) {
        console.log(err);
      }
      this.$store.commit("matrixSetter", {
        type: type,
        key: this.settingMod,
        val: obj,
      });
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
.saveButton {
  // display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 200px;
  width: 500px;
  background: grey;
  pointer-events: all;
  padding: 20px;
  border: 1px solid skyblue;
  border-radius: 20px;
  p {
    text-align: center;
    font-size: 30px;
    text-align: center;
    margin-bottom: 50px;
  }
  :deep(.button_box) {
    display: flex;
    justify-content: space-evenly;
    .item {
      color: black !important;
    }
    .tooltipBox {
      color: rgb(244, 196, 143) !important;
      background: red !important;
    }
  }
}
.setting_block {
  z-index: 10;
  position: relative;
  width: 100%;
  height: 100%;
}

.checkbox_sS {
  top: 5px;
  right: 5px;
  width: 2rem;
  height: 2rem;
}

.imgBg_sS {
  left: 5px;
  top: 5px;
}

.left_slider_in {
  left: 45px !important;
}

.right_slider_in {
  right: 45px !important;
}

.left_block {
  position: absolute;
  pointer-events: all;
  top: 150px;
  left: -1600px;
  transition: left 1s;
  -moz-transition: left 1s; /* Firefox 4 */
  -webkit-transition: left 1s; /* Safari and Chrome */
  -o-transition: left 1s; /* Opera */
  background: rgba(255, 255, 255, 0.5);
}

.right_block {
  position: absolute;
  pointer-events: all;
  top: 150px;
  right: -1600px;
  transition: right 1s;
  -moz-transition: right 1s; /* Firefox 4 */
  -webkit-transition: right 1s; /* Safari and Chrome */
  -o-transition: right 1s; /* Opera */
  background: rgba(255, 255, 255, 0.5);
}

.leftButton_sS {
  width: 5rem;
  height: 3rem;
  right: 0px;
  bottom: -4rem;
}

.rightButton_sS {
  width: 5rem;
  height: 3rem;
  left: 0px;
  bottom: -4rem;
}

.select_sS {
  top: 5px;
  left: 5px;
}

.el-button + .el-button {
  margin-left: initial !important;
}

.el-select-dropdown__item {
  color: #fff !important;
}
.el-select-dropdown__item:hover {
  color: #606266 !important;
}
</style>
<style>
.setting_block .el-button {
  background: #99f5ff;
  color: #409eff;
}
</style>
